import _ from '@/utils/lodash-optimized'
import PropTypes from 'prop-types'
import './styles.scss'

export function FlatButton ({ disabled, label, grey, teal, long, ...rest }) {
  let className = 'nh-flat-button'
  if (grey) {
    className = `${className} grey`
  }
  if (long) {
    className = `${className} long`
  }
  if (teal) {
    className = `${className} teal`
  }

  return (
    <button
      type='button'
      name='nh-button'
      className={className}
      disabled={disabled}
      {...rest}
    >
      {_.toUpper(label)}
    </button>
  )
}

FlatButton.propTypes = {
  label: PropTypes.string.isRequired,

  onClick: PropTypes.any.isRequired,
  grey: PropTypes.bool,
  disabled: PropTypes.bool,
  long: PropTypes.bool
}
